export function iconForTool(name: string): string {
  const n = String(name || '').toLowerCase();
  switch (n) {
    case 'codebase_search':
      return 'search';
    case 'read_file':
      return 'description';
    case 'grep':
      return 'find_in_page';
    case 'delete_file':
      return 'delete';
    case 'doclens':
      return 'article';
    case 'drive_search_documents':
      return 'search';
    case 'drive_fetch_document_content':
      return 'description';
    case 'drive_fetch_document_chunked':
      return 'view_agenda';
    case 'drive_process_next_chunk':
      return 'skip_next';
    case 'run_workflow':
      return 'settings';
    case 'run_workflow_step':
      return 'play_arrow';
    case 'search_gemini_transcripts':
      return 'subtitles';
    case 'propose_team':
      return 'group_add';
    case 'team_guess':
      return 'lightbulb';
    case 'team_analyzer':
      return 'insights';
    default:
      return 'build';
  }
}
